export default __webpack_public_path__ + "components/weather-icon/static/nightpartcloud-e07d54d0eef96847d8b4b5fda15f1ead.png";